import AdminHeader from "components/Headers/AdminHeader";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useMemo } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  UncontrolledTooltip,
  Input,
  Badge,
} from "reactstrap";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import {
  DEFAULT_RECORDS_PER_PAGE,
  fixedWidthCustomStyle,
} from "constants/CommonConstants";
import {
  ISOToHumanReadableDate,
  showAlert,
} from "components/CommonComponents/CommonFunctions";
import Select, { components } from "react-select";
import { COURSE_LEVELS, CERTIFICATE_TYPE, ROLE } from "components/constant";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonModal from "components/CommonComponents/CommonModal";

const CERTIFICATE_STATIC_DATA = {
  issued: [
    {
      id: "1",
      jointerId: "JT001",
      traineeName: "Amit Kumar",
      courseName: "Electrical Safety Fundamentals",
      courseLevel: "Beginner",
      certificateNumber: "CERT-001",
      certificateType: "Individual",
      certificateStatus: "ISSUED",
      issueDate: "2023-01-10T17:30:00",
      validTill: "2024-01-10T17:30:00",
      issuedBy: "Admin",
      completionDate: "2025-01-05T17:30:00",
    },
    {
      id: "2",
      jointerId: "JT002",
      traineeName: "Neha Sharma",
      courseName: "Advanced Power Systems",
      courseLevel: "Advanced",
      certificateNumber: "CERT-002",
      certificateType: "Individual",
      certificateStatus: "ISSUED",
      issueDate: "2023-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Admin",
      completionDate: "2026-01-01T17:30:00",
    },
    {
      id: "3",
      jointerId: "JT003",
      traineeName: "Rahul Verma",
      courseName: "Industrial Wiring & Cabling",
      courseLevel: "Intermediate",
      certificateNumber: "CERT-003",
      certificateType: "Group",
      certificateStatus: "ISSUED",
      issueDate: "2023-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Instructor",
      completionDate: "2026-01-01T17:30:00",
    },
    {
      id: "4",
      jointerId: "JT004",
      traineeName: "Pooja Singh",
      courseName: "Basic Electrical Installation",
      courseLevel: "Beginner",
      certificateNumber: "CERT-004",
      certificateType: "Individual",
      certificateStatus: "ISSUED",
      issueDate: "2023-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Instructor",
      completionDate: "2026-01-01T17:30:00",
    },
    {
      id: "5",
      jointerId: "JT005",
      traineeName: "Suresh Patel",
      courseName: "High Voltage Engineering",
      courseLevel: "Advanced",
      certificateNumber: "CERT-005",
      certificateType: "Group",
      certificateStatus: "ISSUED",
      issueDate: "2023-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Admin",
      completionDate: "2026-01-01T17:30:00",
    },
    {
      id: "6",
      jointerId: "JT006",
      traineeName: "Kiran Rao",
      courseName: "Electrical Maintenance Basics",
      courseLevel: "Beginner",
      certificateNumber: "CERT-006",
      certificateType: "Individual",
      certificateStatus: "ISSUED",
      issueDate: "2023-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Admin",
      completionDate: "2026-01-01T17:30:00",
    },
    {
      id: "7",
      jointerId: "JT007",
      traineeName: "Anjali Mehta",
      courseName: "PLC & Control Systems",
      courseLevel: "Intermediate",
      certificateNumber: "CERT-007",
      certificateType: "Individual",
      certificateStatus: "ISSUED",
      issueDate: "2023-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Instructor",
      completionDate: "2026-01-01T17:30:00",
    },
    {
      id: "8",
      jointerId: "JT008",
      traineeName: "Vikas Jain",
      courseName: "Electrical Measurements & Instruments",
      courseLevel: "Beginner",
      certificateNumber: "CERT-008",
      certificateType: "Group",
      certificateStatus: "ISSUED",
      issueDate: "2023-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Instructor",
      completionDate: "2026-01-01T17:30:00",
    },
    {
      id: "9",
      jointerId: "JT009",
      traineeName: "Ritu Malhotra",
      courseName: "Power Electronics",
      courseLevel: "Advanced",
      certificateNumber: "CERT-009",
      certificateType: "Individual",
      certificateStatus: "ISSUED",
      issueDate: "2023-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Admin",
      completionDate: "2026-01-01T17:30:00",
    },
    {
      id: "10",
      jointerId: "JT010",
      traineeName: "Manish Gupta",
      courseName: "Electrical Machines",
      courseLevel: "Intermediate",
      certificateNumber: "CERT-010",
      certificateType: "Group",
      certificateStatus: "ISSUED",
      issueDate: "2023-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Admin",
      completionDate: "2026-01-01T17:30:00",
    },
    {
      id: "11",
      jointerId: "JT011",
      traineeName: "Sneha Iyer",
      courseName: "SCADA Systems",
      courseLevel: "Advanced",
      certificateNumber: "CERT-011",
      certificateType: "Individual",
      certificateStatus: "ISSUED",
      issueDate: "2023-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Admin",
      completionDate: "2026-01-01T17:30:00",
    },
    {
      id: "12",
      jointerId: "JT012",
      traineeName: "Arjun Nair",
      courseName: "Renewable Energy Systems",
      courseLevel: "Beginner",
      certificateNumber: "CERT-012",
      certificateType: "Group",
      certificateStatus: "ISSUED",
      issueDate: "2024-11-10T17:30:00",
      validTill: "2024-08-10T17:30:00",
      issuedBy: "Admin",
      completionDate: "2026-01-01T17:30:00",
    },
  ],
  pending: [
    {
      id: "1",
      jointerId: "JT101",
      traineeName: "Rohan Das",
      courseName: "Electrical Safety Fundamentals",
      courseLevel: "Beginner",
      certificateType: "Individual",
      certificateStatus: "PENDING",
      completionDate: "2025-02-01T17:30:00",
    },
    {
      id: "2",
      jointerId: "JT102",
      traineeName: "Meera Joshi",
      courseName: "Industrial Wiring & Cabling",
      courseLevel: "Intermediate",
      certificateType: "Group",
      certificateStatus: "PENDING",
      completionDate: "2025-02-02T17:30:00",
    },
    {
      id: "3",
      jointerId: "JT103",
      traineeName: "Sanjay Kulkarni",
      courseName: "High Voltage Engineering",
      courseLevel: "Advanced",
      certificateType: "Individual",
      certificateStatus: "PENDING",
      completionDate: "2025-02-03T17:30:00",
    },
    {
      id: "4",
      jointerId: "JT104",
      traineeName: "Kavita Shah",
      courseName: "PLC & Control Systems",
      courseLevel: "Beginner",
      certificateType: "Group",
      certificateStatus: "PENDING",
      completionDate: "2025-02-04T17:30:00",
    },
    {
      id: "5",
      jointerId: "JT105",
      traineeName: "Nikhil Bansal",
      courseName: "Industrial Wiring & Cabling",
      courseLevel: "Intermediate",
      certificateType: "Individual",
      certificateStatus: "PENDING",
      completionDate: "2025-02-05T17:30:00",
    },
    {
      id: "6",
      jointerId: "JT106",
      traineeName: "Divya Kapoor",
      courseName: "High Voltage Engineering",
      courseLevel: "Beginner",
      certificateType: "Group",
      certificateStatus: "PENDING",
      completionDate: "2025-02-06T17:30:00",
    },
    {
      id: "7",
      jointerId: "JT107",
      traineeName: "Mohit Arora",
      courseName: "PLC & Control Systems",
      courseLevel: "Intermediate",
      certificateType: "Individual",
      certificateStatus: "PENDING",
      completionDate: "2025-02-07T17:30:00",
    },
  ],
  expired: [
    {
      id: "1",
      jointerId: "JT201",
      traineeName: "Alok Singh",
      courseName: "Electrical Machines",
      courseLevel: "Intermediate",
      certificateNumber: "CERT-201",
      certificateType: "Individual",
      certificateStatus: "EXPIRED",
      issueDate: "2023-01-10T17:30:00",
      validTill: "2024-01-10T17:30:00",
      issuedBy: "Admin",
      completionDate: "2023-01-05T17:30:00",
    },
    {
      id: "2",
      jointerId: "JT202",
      traineeName: "Nisha Reddy",
      courseName: "Electrical Measurements & Instruments",
      courseLevel: "Advanced",
      certificateNumber: "CERT-202",
      certificateType: "Group",
      certificateStatus: "EXPIRED",
      issueDate: "2023-02-15T17:30:00",
      validTill: "2024-02-15T17:30:00",
      issuedBy: "Instructor",
      completionDate: "2023-02-10T17:30:00",
    },
    {
      id: "3",
      jointerId: "JT203",
      traineeName: "Deepak Chauhan",
      courseName: "SCADA Systems",
      courseLevel: "Intermediate",
      certificateNumber: "CERT-203",
      certificateType: "Individual",
      certificateStatus: "EXPIRED",
      issueDate: "2023-03-20T17:30:00",
      validTill: "2024-03-20T17:30:00",
      issuedBy: "Admin",
      completionDate: "2023-03-15T17:30:00",
    },
    {
      id: "4",
      jointerId: "JT204",
      traineeName: "Swati Kulkarni",
      courseName: "Advanced Power Systems",
      courseLevel: "Beginner",
      certificateNumber: "CERT-204",
      certificateType: "Group",
      certificateStatus: "EXPIRED",
      issueDate: "2023-04-18T17:30:00",
      validTill: "2024-04-18T17:30:00",
      issuedBy: "Instructor",
      completionDate: "2023-04-12T17:30:00",
    },
    {
      id: "5",
      jointerId: "JT205",
      traineeName: "Harish Patel",
      courseName: "Advanced Power Systems",
      courseLevel: "Advanced",
      certificateNumber: "CERT-205",
      certificateType: "Individual",
      certificateStatus: "EXPIRED",
      issueDate: "2023-05-22T17:30:00",
      validTill: "2024-05-22T17:30:00",
      issuedBy: "Admin",
      completionDate: "2023-05-18T17:30:00",
    },
    {
      id: "6",
      jointerId: "JT206",
      traineeName: "Komal Jain",
      courseName: "Substation Operations & Maintenance",
      courseLevel: "Beginner",
      certificateNumber: "CERT-206",
      certificateType: "Group",
      certificateStatus: "EXPIRED",
      issueDate: "2023-06-25T17:30:00",
      validTill: "2024-06-25T17:30:00",
      issuedBy: "Instructor",
      completionDate: "2023-06-20T17:30:00",
    },
    {
      id: "7",
      jointerId: "JT207",
      traineeName: "Gaurav Malhotra",
      courseName: "Substation Operations & Maintenance",
      courseLevel: "Intermediate",
      certificateNumber: "CERT-207",
      certificateType: "Individual",
      certificateStatus: "EXPIRED",
      issueDate: "2023-07-28T17:30:00",
      validTill: "2024-07-28T17:30:00",
      issuedBy: "Admin",
      completionDate: "2023-07-22T17:30:00",
    },
    {
      id: "8",
      jointerId: "JT208",
      traineeName: "Isha Khanna",
      courseName: "Electrical Measurements & Instruments",
      courseLevel: "Advanced",
      certificateNumber: "CERT-208",
      certificateType: "Group",
      certificateStatus: "EXPIRED",
      issueDate: "2023-08-30T17:30:00",
      validTill: "2024-08-30T17:30:00",
      issuedBy: "Instructor",
      completionDate: "2023-08-25T17:30:00",
    },
    {
      id: "9",
      jointerId: "JT209",
      traineeName: "Siddharth Bose",
      courseName: "Power Electronics",
      courseLevel: "Beginner",
      certificateNumber: "CERT-209",
      certificateType: "Individual",
      certificateStatus: "EXPIRED",
      issueDate: "2023-09-15T17:30:00",
      validTill: "2024-09-15T17:30:00",
      issuedBy: "Admin",
      completionDate: "2023-09-10T17:30:00",
    },
    {
      id: "10",
      jointerId: "JT210",
      traineeName: "Anita Paul",
      courseName: "Electrical Machines",
      courseLevel: "Intermediate",
      certificateNumber: "CERT-210",
      certificateType: "Group",
      certificateStatus: "EXPIRED",
      issueDate: "2023-10-20T17:30:00",
      validTill: "2024-10-20T17:30:00",
      issuedBy: "Instructor",
      completionDate: "2023-10-15T17:30:00",
    },
  ],
};

const IssuanceList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pageNum, setPageNum] = useState(1);
  const [activeTab, setActiveTab] = useState("issued");
  const issuanceList = CERTIFICATE_STATIC_DATA[activeTab] || [];
  const [issuedListState, setIssuedListState] = useState({
    isLoading: false, //true
    isSearched: false,
    error: "",
    noRecords: false,
  });
  const [searchState, setSearchState] = useState({
    traineeName: "",
    courseName: "",
    courseLevel: null,
    certificateType: null,
    certificateNo: null,
    issuedDate: null,
    issuedBy: null,
    filterParams: [],
  });
  const [preview, setPreview] = useState({
    isOpen: false,
    image: "",
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setActiveTab(params.get("tab") || "issued");
  }, [location.search]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      const params = new URLSearchParams(location.search);
      params.set("tab", tab);
      navigate(`${location.pathname}?${params.toString()}`, {
        replace: true,
      });
    }
  };

  const handleClear = () => {
    setSearchState({
      traineeName: "",
      courseName: "",
      courseLevel: null,
      certificateType: null,
      certificateNo: null,
      issuedDate: null,
      issuedBy: null,
      filterParams: [],
    });
    if (pageNum !== 1) setPageNum(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const ViewCertificate = (rowData) => {
    setPreview({
      isOpen: true,
      image: require("../../../assets/img/certificates/template2.jpg"),
    });
  };

  const handlePreviewCancel = () => {
    setPreview({
      isOpen: false,
      image: "",
    });
  };

  const confirmIssueCertificate = (rowData) => {
    showAlert({
      title: "Issue Certificate",
      type: "warning",
      message: (
        <>
          <p className="mb-1">
            Are you sure you want to issue the certificate for
          </p>
          <strong>{rowData.traineeName}</strong>
        </>
      ),
      confirmText: "Yes, Issue",
      cancelText: "Cancel",
      confirmStyle: "danger",
      onConfirm: () => handleIssueCertificate(rowData),
    });
  };

  const handleIssueCertificate = async (rowData) => {
    try {
      //Api call here
      showAlert({
        title: "Success",
        type: "success",
        message: "Certificate issued successfully",
        showCancel: false,
        confirmText: "OK",
        confirmStyle: "default",
      });
    } catch (error) {
      showAlert({
        title: "Error",
        type: "warning",
        message: "Failed to issue certificate. Please try again.",
        showCancel: false,
        confirmText: "OK",
      });
    }
  };

  const handleSearch = () => {};

  const column = useMemo(
    () => [
      {
        Header: "Sr. No.",
        accessor: "id",
      },
      {
        Header: "Jointer ID",
        accessor: "jointerId",
      },
      {
        Header: "Trainee Name",
        accessor: "traineeName",
      },
      {
        Header: "Course Name",
        accessor: "courseName",
      },
      {
        Header: "Course Level",
        accessor: "courseLevel",
      },

      {
        Header: "Certificate Type",
        accessor: "certificateType",
      },

      ...(activeTab !== "pending"
        ? [
            {
              Header: "Certificate Number",
              accessor: "certificateNumber",
              Cell: ({ value }) => value || "—",
            },
            {
              Header: "Issue Date",
              accessor: "issueDate",
              Cell: ({ value }) => ISOToHumanReadableDate(value),
            },
            {
              Header: "Validity Till",
              accessor: "validTill",
              Cell: ({ value }) => ISOToHumanReadableDate(value),
            },
            {
              Header: "Issued By",
              accessor: "issuedBy",
            },
          ]
        : []),

      {
        Header: " Completion Date",
        accessor: "completionDate",
        Cell: ({ value }) => ISOToHumanReadableDate(value),
      },
      {
        Header: "Status",
        accessor: "certificateStatus",
        Cell: ({ value }) => (
          <Badge
            color={
              value === "ISSUED"
                ? "success"
                : value === "PENDING"
                  ? "secondary"
                  : value === "EXPIRED"
                    ? "warning"
                    : "info"
            }
            pill
          >
            {value}
          </Badge>
        ),
      },
      {
        Header: "Actions",
        disableSortBy: true,
        Cell: ({ row }) => {
          const { certificateStatus } = row.original;
          const tooltipId = `details-${row.original.jointerId}`;

          return (
            <div className="d-flex align-items-center">
              {certificateStatus !== "PENDING" && (
                <>
                  <Button
                    size="sm"
                    id={tooltipId}
                    className="btn-link p-0"
                    onClick={() => ViewCertificate(row.original)}
                  >
                    <i className="fas fa-eye mr-1" />
                  </Button>
                  <UncontrolledTooltip target={tooltipId}>
                    View Certificate
                  </UncontrolledTooltip>
                </>
              )}

              {certificateStatus === "PENDING" && (
                <Button
                  size="sm"
                  color="default"
                  className="p-2 btn-deep-blue"
                  onClick={() => confirmIssueCertificate(row.original)}
                >
                  Issue Certificate
                </Button>
              )}
            </div>
          );
        },
      },
    ],
    [activeTab],
  );

  return (
    <>
      <AdminHeader />

      <Container className="mt--7" fluid>
        <Row>
          <Col md="12">
            <>
              <h3 className="mb-0 mt-3 text-white-input ">
                Certificate Issuance
              </h3>
              <Card className="mt-3">
                <CardHeader className="pb-0 d-flex justify-content-between align-items-center course-sticky-header">
                  <Nav className="custom-tabs cursor">
                    <NavItem>
                      <NavLink
                        className={activeTab === "issued" ? "active" : ""}
                        onClick={() => toggleTab("issued")}
                      >
                        Issued
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={activeTab === "pending" ? "active" : ""}
                        onClick={() => toggleTab("pending")}
                      >
                        Pending
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={activeTab === "expired" ? "active" : ""}
                        onClick={() => toggleTab("expired")}
                      >
                        Expired
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>
              </Card>

              <TabContent
                activeTab={activeTab}
                className="course-tab-scroll course-details"
              >
                <TabPane className="course-details" tabId={activeTab}>
                  <Card className="mb-3 ">
                    <CardBody>
                      <div className="d-flex align-items-center justify-content-between flex-wrap flex-column flex-md-row">
                        {/* Left side - Filter Inputs + Search */}
                        <div className="d-flex flex-wrap align-items-center filter-group">
                          <Input
                            type="text"
                            placeholder="Search by Jointer Id"
                            className="mr-2 mb-2 filter-input-large"
                            value={searchState.jointerId}
                            onChange={(e) =>
                              setSearchState((prev) => ({
                                ...prev,
                                jointerId: e.target.value,
                              }))
                            }
                            onKeyDown={handleKeyDown}
                          />

                          <Input
                            type="text"
                            placeholder="Search by trainee name"
                            className="mr-2 mb-2 filter-input-large"
                            value={searchState.traineeName}
                            onChange={(e) =>
                              setSearchState((prev) => ({
                                ...prev,
                                traineeName: e.target.value,
                              }))
                            }
                            onKeyDown={handleKeyDown}
                          />

                          <Input
                            type="text"
                            placeholder="Search by course name"
                            className="mr-2 mb-2 filter-input-large"
                            value={searchState.courseName}
                            onChange={(e) =>
                              setSearchState((prev) => ({
                                ...prev,
                                courseName: e.target.value,
                              }))
                            }
                            onKeyDown={handleKeyDown}
                          />

                          {activeTab !== "pending" && (
                            <>
                              <Input
                                type="text"
                                placeholder="Search by Certificate no."
                                className="mr-2 mb-2 mt-1 filter-input-large"
                                value={searchState.certificateNo}
                                onChange={(e) =>
                                  setSearchState((prev) => ({
                                    ...prev,
                                    certificateNo: e.target.value,
                                  }))
                                }
                                onKeyDown={handleKeyDown}
                              />

                              <Select
                                className="mr-2 mb-2 mt-1 filter-select"
                                options={CERTIFICATE_TYPE}
                                placeholder="Certificate type"
                                classNamePrefix="react-select"
                                styles={fixedWidthCustomStyle()}
                              />

                              <div className="d-flex align-items-center mx-2 ">
                                <span className="text-muted mb-0 mr-2">
                                  Issued date
                                </span>
                                <DatePicker
                                  selected={searchState.issuedDate}
                                  onChange={(date) =>
                                    setSearchState((prev) => ({
                                      ...prev,
                                      issuedDate: date,
                                    }))
                                  }
                                  placeholderText="Issued date"
                                  className="form-control mr-2 mb-2 mt-1"
                                  dateFormat="dd-MM-yyyy"
                                />
                              </div>

                              <Select
                                className="mr-2 mb-2 mt-1 filter-select"
                                options={ROLE}
                                placeholder="Issued by"
                                classNamePrefix="react-select"
                                styles={fixedWidthCustomStyle()}
                              />
                            </>
                          )}
                          <Select
                            className="mr-2 mb-2 filter-select"
                            options={COURSE_LEVELS}
                            placeholder="Course level"
                            classNamePrefix="react-select"
                            styles={fixedWidthCustomStyle()}
                          />

                          <Button
                            color="default"
                            // className="d-flex align-items-center btn-deep-blue mb-0"
                            className="d-flex align-items-center mb-2 mt-1 filter-btn btn-deep-blue"
                            onClick={handleSearch}
                          >
                            <i className="fa fa-search mr-1" />
                            Search
                          </Button>

                          {Object.keys(searchState.filterParams).length > 0 && (
                            <Button
                              color="default"
                              className="ml-2 mb-0 mt-1 filter-btn btn-simple"
                              onClick={handleClear}
                            >
                              <i className="fa fa-times mr-1" /> Clear
                            </Button>
                          )}
                        </div>
                      </div>
                      <div className="mt-2 mb-3 mx-1">
                        {issuanceList.length ? (
                          <span className="total-records">
                            Total Records : {issuanceList.length}
                          </span>
                        ) : null}
                      </div>

                      {issuedListState.isLoading ? (
                        <div className="loaderContainer">
                          <i className="fa fa-spinner fa-spin fa-2xl loader" />
                        </div>
                      ) : issuedListState.error ? (
                        <div className="loaderContainer">
                          {issuedListState.error}
                        </div>
                      ) : issuedListState.noRecords ? (
                        <div className="loaderContainer text-muted">
                          No Records found.
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <CommonTable
                            columns={column}
                            data={issuanceList.slice(
                              (pageNum - 1) * DEFAULT_RECORDS_PER_PAGE,
                              pageNum * DEFAULT_RECORDS_PER_PAGE,
                            )}
                            defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                            activePage={pageNum}
                            setPageNum={setPageNum}
                            totalPages={Math.ceil(
                              issuanceList.length / DEFAULT_RECORDS_PER_PAGE,
                            )}
                            showPaginationBottom
                          />
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </TabPane>
              </TabContent>
            </>
          </Col>
        </Row>
      </Container>

      <CommonModal
        isOpen={preview.isOpen}
        toggle={handlePreviewCancel}
        title="Certificate Preview"
        size="xl"
      >
        <div className="text-center p-0 pb-2">
          <img
            src={preview.image}
            alt="Certificate Preview"
            className="img-fluid pb-3"
          />
        </div>
      </CommonModal>
    </>
  );
};

export default IssuanceList;
